import { useContext, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import ReactTable from "../common/react-table/ReactTable";
import { useDispatch, useSelector } from "react-redux";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useLocation } from "react-router-dom";
import Mixpanel from "mixpanel-browser";
import { DndProvider } from "react-dnd";

// import ArchiveDocuments from "../components/dashboardComponent/ArchiveDocuments";
// import StarredDocuments from "../components/dashboardComponent/StarredDocuments";
import CreateDocument from "../components/dashboardComponent/CreateDocument";
import DocumentSideMenu from "../components/dashboardComponent/DocumentSideMenu";
// import UploadDocumentModal from "../components/dashboardComponent/modal/UploadDocumentModal";
import DashboardHeader from "../components/dashboardComponent/DashboardHeader";
import CreateEditorDocumentModal from "../components/dashboardComponent/CreateEditorDocument";
import { getDocuments, setRetrainAllDocuments } from "../features/user-document/documentListingSlice";
import { deleteDocument } from "../features/user-document/deleteDocumentSlice";
import { syncSlice } from "../features/user-document/syncSlice";
import { unSyncSlice } from "../features/user-document/unsyncSlice";
import { archiveDocument } from "../features/user-document/archiveDocumentSlice";
import { favouriteDocument } from "../features/user-document/favouriteDocument";
import { updateDocument } from "../features/user-document/updateDocumentSlice";
import ConfirmationModal from "../common/modal/ConfirmationModal";
import { OK } from "../constants/statusCode";

// import renameImg from "../assets/images/rename.svg";
// import resyncImg from "../assets/images/resync.svg";
// import ActionImg from "../assets/images/action.svg";
/* import syncImg from "../assets/images/status-sync.svg"; */
// import unsyncImg from "../assets/images/unsync_icn.svg";
// import archiveicn from "../assets/images/archiveicn.svg";
import editImgIcn from "../assets/images/date-checked.svg";
// import editImg from "../assets/images/edit.svg";
import favStar from "../assets/images/fav-star.svg";
import star from "../assets/images/star.svg";
import pdfImg from "../assets/images/pdf_icn.svg";
import docImg from "../assets/images/doc_icn.svg";
// import htmlImg from "../assets/images/html_icn.svg";
import sitemapImg from "../assets/images/xml-icon.svg";
import webImg from "../assets/images/web-icon.svg";
import rssImg from "../assets/images/rss-icon.svg";
// import trashImg from "../assets/images/trash.svg";
// import syncImg from "../assets/images/check_icn.svg";
// import inProgressImg from "../assets/images/syncwith_progress.svg";
// import notsync_icn from "../assets/images/notsync_icn.svg";
// import close_arrow from "../assets/images/close-arrow.svg";
// import actionSync from "../assets/images/status-sync.svg";
import FilePreviewModal from "../components/dashboardComponent/modal/FilePreviewModal";
import { getSingleDocument } from "../features/user-document/getDocumentSlice";
// import LabelModal from "../components/dashboardComponent/modal/LabelModal";
// import { showSuccess } from "../utils/messageHelper";
import { labelListing } from "../features/user-document/label-listing";
// import { deleteLabel } from "../features/user-document/deleteLabelSlice";
import crossImg from "../assets/images/cross_icn.svg";
import writeImg from "../assets/images/writei_icn.svg";
// import viewSummary from "../assets/images/view_summary.svg";
// import RedirectIcon from "../assets/images/redirect.svg";

import { removeTags } from "../features/user-document/removeTagsSlice";
import {
  getColoroCodeCloseText,
  getColoroCodeString,
  getColoroCodeStringText,
  getTimeAgoString,
  NoModuleRights,
  RoleRightsForModule,
} from "../utils/utils";
import VerifyEmailModal from "../common/modal/VerifyEmailModal";
// import { _init, socket } from "../utils/socketService";
import { labelDocument } from "../features/user-document/labelDocumentSaveSlice";
/* import DemoHightlight from "../components/dashboardComponent/DemoHighlight"; */
import { SocketContext } from "../socket/socket";
import { resyncDocuments } from "../features/user-document/resyncSlice";
import ViewSummayModal from "../common/modal/ViewSummaryModal";
import DocumentStatus from "../components/dashboardComponent/DocumentStatus";
import DocumentAction from "../components/dashboardComponent/DocumentAction";

const Dashboard = () => {
  const [isActive, setIsActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [currentModal, setCurrentModal] = useState("");
  const [subCategories, setSubCategories] = useState("Documents");
  const [previousSubCategories, setPreviousSubCategories] = useState("");
  const [isFromFilePreview, setIsFromFilePreview] = useState(false);
  const [uuid, setUuid] = useState("");
  const [edituuid, setEditUuid] = useState("");
  // const [syncUnsync, setSyncUnsync] = useState(0);
  const [selectedRowsID, setSelectedRowsID] = useState([]);
  const [docUrl, setDocUrl] = useState({});
  const [fileName, setFileName] = useState("");
  const [labelID, setLabelId] = useState("");
  const [isLabelDelete, SetIsLabelDelete] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState({});
  const [selectedCheckbox, setSelectedCheckbox] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [labelArray, setLabelArray] = useState([]);
  const [showVerifyEmailModal, setShowVerifyEmailModal] = useState(false);
  const [listOfDocuments, setListOfDocuments] = useState([]);
  const [documentsListForUpdate, setDocumentsListForUpdate] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [documentLength, setDocumentLength] = useState(0);
  const [socketDocumentData, setSocketDocumentData] = useState([]);
  const [updatedStatusDocuments, setUpdatedStatusDocuments] = useState([]);
  const [processedDocuments, setProcessedDocuments] = useState([]);
  const [summaryText, setSummaryText] = useState("");

  const [summaryTextData, setSummaryTextData] = useState("");
  const modalData = useRef("");

  const socketContext = useContext(SocketContext);
  const dispatch = useDispatch();

  var socketData = [];

  const {
    documentListing = null,
    // documentListSuccess = null,
    removeTagsLoading = null,
    documentListLoading = null,
    documentListData = null,
    total_records = null,
    total_pages = null,
    retrainAllDocuments = null,
  } = useSelector((state) => ({
    removeTagsLoading: state?.removeTagsSlice?.isLoading,
    // documentListSuccess: state?.documentListing?.isSuccess,
    documentListLoading: state?.documentListing?.isLoading,
    documentListData: state?.documentListing?.documentListing,
    documentListing: state?.documentListing,
    total_records: state?.documentListing?.totalCount,
    labelListingData: state?.labelListingSlice?.responseData?.label,
    total_pages: state?.documentListing?.total_pages,
    retrainAllDocuments: state?.documentListing?.retrainAllDocuments,
  }));

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  useEffect(() => {
    if (searchParams != null && searchParams.get("email_verify") != null) {
      setShowVerifyEmailModal(true);
    }
  }, []);

  useEffect(() => {
    setListOfDocuments(documentListData);
    setDocumentsListForUpdate(documentListData);
    setSocketDocumentData(documentListData);
  }, [documentListData]);

  const toggleModal = () => {
    setCurrentModal("");
    setEditUuid("");
    setUuid("");
  };
  /* let projectData = JSON.parse(localStorage.getItem("_user"));
  useEffect(() => {
    dispatch(labelListing(projectData?.projects[0]?.uuid));
  },[]) */

  let projectData = JSON.parse(localStorage.getItem("_user"));

  useEffect(() => {
    if (subCategories === "Documents") {
      dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          project_uuid: projectData?.projects[0]?.uuid,
          search: searchValue,
        })
      ).then((data) => {
        setDocumentLength(data?.payload?.data?.data?.documents?.length);
      });
    } else if (subCategories === "Archive") {
      if (documentListData.length > 0) {
        dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
            search: searchValue,
            type: "archive",
          })
        );
      }
    } else if (subCategories === "Starred") {
      if (documentListData.length > 0) {
        dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
            search: searchValue,
            type: "favourite",
          })
        );
      }
    }
  }, [perPage, currentPage, searchValue]);

  useEffect(() => {
    dispatch(labelListing(projectData?.projects[0]?.uuid)).then((data) => {
      setLabelArray(data?.payload?.data?.responseData?.label);
    });
    socketContext.initiateConnection();
  }, []);

  // useEffect(() => {
    // _init();
    // socketContext?.socket?.on("success", (res) => {
    //   console.log("success");
    //   /* [
    //     res.documentUUID === prevDocuments.documentUUID
    //       ? (prevDocuments.is_synced = res.is_synced)
    //       : res,
    //   ] */
    //   if (socketData.length > 0) {
    //     const updatedData = socketData.map((data, idx) => {
    //       if (data?.documentUUID === res?.documentUUID) {
    //         return {
    //           ...data,
    //           is_synced: res?.is_synced,
    //           synced_at: res?.synced_at,
    //         };
    //       }
    //       return data;
    //     });
    //     setUpdatedStatusDocuments([...updatedData, res]);
    //     socketData.push(...updatedData, res);
    //   } else {
    //     setUpdatedStatusDocuments([res]);
    //     socketData.push(res);
    //   }
    //   if (res.documentUUID === modalData.current.uuid) {
    //     if (res.is_synced === 1) {
    //       setSummaryText(res.summary_text);
    //       setSummaryRegenerateButtonDisable(false);
    //     }
    //     const updatedModalData = {
    //       ...modalData.current,
    //       is_synced: res.is_synced, // Replace newValue with the updated value
    //     };
    //     modalData.current = updatedModalData;
    //     setSummaryTextData(modalData.current);
    //   }

    //   setProcessedDocuments(prevDocuments => {
    //     const unMatchedDocument = prevDocuments.filter(doc => doc.documentUUID !== res.documentUUID);
    //     return [...unMatchedDocument];
    //   });

    //   //THIS IS FOR GLOBAL RESYNC
    //   /*  setDocumentsListForUpdate((updatedListData) => {
    //     return updatedListData.map((particularData) => {
    //       console.log(particularData, "PARTICULARDAAATTTAAA:::");
    //       if (particularData.uuid === res.documentUUID) {
    //         return {
    //           ...particularData,
    //           is_synced: res?.is_synced,
    //         };
    //       }
    //       return particularData;
    //     });
    //   }); */
    //   /* let updatedData = socketDocumentData.map((d) => {
    //     if (d?.uuid === res?.documentUUID) {
    //       return {
    //         ...d,
    //         is_synced: res?.is_synced,
    //       };
    //     }
    //     return d;
    //   });
    //   setSocketDocumentData(updatedData); */
    //   // let data = JSON.parse(localStorage.getItem("_user"));
    //   // dispatch(
    //   //   getDocuments({
    //   //     perPage: perPage,
    //   //     page: currentPage,
    //   //     project_uuid: data?.projects[0]?.uuid,
    //   //     type:
    //   //       subCategories === "Archive"
    //   //         ? "archive"
    //   //         : subCategories === "Starred"
    //   //           ? "favourite"
    //   //           : "",
    //   //   })
    //   // );
    //   // setSubCategories("Documents");
    // });
  // }, [socketContext, socketDocumentData]);

  // useEffect(() => {
  //   const documentProcessedEvent = (res) => {
  //     setProcessedDocuments(prevDocuments => {
  //       const unMatchedDocument = prevDocuments.filter(doc => doc.documentUUID !== res.documentUUID);
  //       return [...unMatchedDocument, res];
  //     });
  //   };
  //   if (socketContext?.socket) {
  //     socketContext.socket.on("documentProcessed", documentProcessedEvent);
  //   }
  //   return () => {
  //     socketContext?.socket?.off("documentProcessed");
  //   }
  // }, [socketContext, processedDocuments]);

  useEffect(() => {
    if (retrainAllDocuments && listOfDocuments.length > 0) {
      // resync all documents
      dispatch(setRetrainAllDocuments(false));
      resyncDocument(listOfDocuments.map(doc => doc.uuid));
    }
  }, [retrainAllDocuments, listOfDocuments]);

  const onClickActive = () => {
    setIsActive(!isActive);
  };

  const handleTotalPage = (page) => {
    setPerPage(Number(page));
    setCurrentPage(1);
  };

  const handleCurrentPage = (page) => {
    setCurrentPage(Number(page));
  };

  const labelDeteleToggel = () => {
    SetIsLabelDelete(!isLabelDelete);
  };

  /* const handleDeleteLabel = async () => {
    Mixpanel.track("Delete label Button Clicked", {
      Page: "Delete label modal",
    });
    
    const { payload } = await dispatch(deleteLabel(labelID));
    if (payload.status === OK) {
      showSuccess("Label deleted successfully!");
      await dispatch(labelListing(projectData?.projects[0]?.uuid));
      await dispatch(
        getDocuments({
          perPage: perPage,
          page: 1,
          project_uuid: projectData?.projects[0]?.uuid,
          search: searchValue,
        })
      );
      labelDeteleToggel();
      setCurrentModal("");
    }
  }; */

  const handleDelete = () => {
    let uuidArray = [];
    if (uuid) {
      uuidArray.push(uuid);
    } else {
      selectedRowsID.length > 0 &&
        selectedRowsID.map((data, index) => {
          uuidArray.push(data.original?.uuid);
        });
    }
    Mixpanel.track("Delete Document Button Clicked", {
      Page: "Delete document button",
    });
    dispatch(
      deleteDocument({
        values: uuidArray,
        project_uuid: projectData?.projects[0]?.uuid,
      })
    ).then((data) => {
      if (data?.payload?.status === OK) {
        // showSuccess("Document Deleted successfully!");
        setUuid("");
        dispatch(
          getDocuments({
            perPage: perPage,
            page:
              uuidArray.length === socketDocumentData?.length &&
              currentPage === total_pages &&
              currentPage !== 1 &&
              currentPage !== 0
                ? currentPage - 1
                : currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
            search: searchValue,
            type:
              subCategories === "Archive"
                ? "archive"
                : subCategories === "Starred"
                ? "favourite"
                : "",
          })
        );
        currentPage !== 1 &&
          currentPage !== 0 &&
          setCurrentPage(
            uuidArray.length === socketDocumentData?.length &&
              currentPage === total_pages
              ? currentPage - 1
              : currentPage
          );
        setSelectedRowsID([]);

        toggleModal();
      }
    });
  };

  const handleEditorDelete = () => {
    let uuidArray = [];
    if (uuid) {
      uuidArray.push(uuid);
    }
    selectedRowsID.length > 0 &&
      selectedRowsID.map((data, index) => {
        uuidArray.push(data.original?.uuid);
      });
    Mixpanel.track("Delete Document Button Clicked", {
      Page: "Delete document button",
    });
    dispatch(
      deleteDocument({
        values: uuidArray,
        project_uuid: projectData?.projects[0]?.uuid,
      })
    ).then((data) => {
      if (data?.payload?.status === OK) {
        // showSuccess("Document Deleted successfully!");
        setUuid("");
        dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
            search: searchValue,
            type:
              previousSubCategories === "Archive"
                ? "archive"
                : previousSubCategories === "Starred"
                ? "favourite"
                : "",
          })
        );
        if (isFromFilePreview) {
          setSubCategories(previousSubCategories);
        }
        setSelectedRowsID([]);
        toggleModal();
      }
    });
  };

  const handleArchive = (uuid) => {
    Mixpanel.track("Archieve document button Clicked", {
      Page: "Documents tab",
    });
    dispatch(
      archiveDocument({
        document_uuid: uuid,
        project_uuid: projectData?.projects[0]?.uuid,
      })
    ).then(() => {
      dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          project_uuid: projectData?.projects[0]?.uuid,
          type: subCategories === "Starred" ? "favourite" : "",
          search: searchValue,
        })
      );
      toggleModal();
    });
  };

  const handleFavouriteUnfavourite = (uuid, is_favourite) => {
    Mixpanel.track("Favorite or unfavourite document button Clicked", {
      Page: "Documents tab",
    });
    let isFavourite = "";
    isFavourite = is_favourite === 0 ? 1 : 0;

    let indexRow = null;
    const updatedRows = [...documentListData];
    let rowToUpdate = {
      ...updatedRows.find((d, i) => {
        if (d.uuid == uuid) {
          indexRow = i;
          return d;
        }
      }),
    };
    rowToUpdate.is_favourite = isFavourite;
    updatedRows[indexRow] = rowToUpdate;
    setListOfDocuments(updatedRows);
    setDocumentsListForUpdate(updatedRows);
    setIsLoading(true);
    dispatch(favouriteDocument({ uuid: uuid, isFavourite: isFavourite })).then(
      () => {
        setIsLoading(false);
        dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
            type: subCategories === "Starred" ? "favourite" : "",
            search: searchValue,
          })
        );
        toggleModal();
      }
    );
  };

  const syncUnsyncToggle = async (uuid, syncUnsync) => {
    if (syncUnsync === 0) {
      Mixpanel.track("Sync document button Clicked", {
        Page: "Documents tab",
      });
      const { payload } = await dispatch(
        syncSlice({
          document_uuid: uuid,
          project_uuid: projectData?.projects[0]?.uuid,
        })
      );
      if (payload.status === OK) {
        await dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
            search: searchValue,
            type:
              subCategories === "Archive"
                ? "archive"
                : subCategories === "Starred"
                ? "favourite"
                : "",
          })
        );
        setUpdatedStatusDocuments([]);

        /* toggleModal(); */
      }
    } else {
      Mixpanel.track("Unsync document button Clicked", {
        Page: "Documents tab",
      });
      const { payload } = await dispatch(
        unSyncSlice({
          document_uuid: uuid,
          project_uuid: projectData?.projects[0]?.uuid,
        })
      );
      if (payload.status === OK) {
        await dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
            search: searchValue,
            type:
              subCategories === "Archive"
                ? "archive"
                : subCategories === "Starred"
                ? "favourite"
                : "",
          })
        );
        setUpdatedStatusDocuments([]);

        /* toggleModal(); */
      }
    }
  };

  const editCell = async (index, id, value, uuid) => {
    let EditformData = {};
    EditformData.title = value;
    EditformData.project_uuid = projectData?.projects[0]?.uuid;
    Mixpanel.track("Edit document button Clicked", {
      Page: "Documents tab text change",
    });
    const { payload } = await dispatch(
      updateDocument({ id: uuid, documentData: EditformData })
    );
    if (payload.status === OK) {
      /* showSuccess("Document edit successfully!"); */
      await dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          project_uuid: projectData?.projects[0]?.uuid,
          type: subCategories === "Starred" ? "favourite" : "",
          search: searchValue,
        })
      );
      // setSubCategories("Documents");
      setEditUuid("");
    }
  };

  const previewOnClick = async (uuid, type, extension) => {
    setUuid(uuid);

    setPreviousSubCategories(subCategories);
    if (extension === "pdf" || type === "text") {
      setSubCategories("filePreview");
    }
    /* setCurrentModal("filePreview"); */
    dispatch(getSingleDocument({ id: uuid, docType: type })).then((data) => {
      /* if(data?.payload.status === OK){ */
      /* let encodeUrl = encodeURIComponent(data?.payload?.data?.document?.url); */
      let encodeUrl = data?.payload?.data?.document?.url;
      setDocUrl({
        file_name: data?.payload?.data?.document?.file_name,
        url: encodeUrl,
        type: data?.payload?.data?.document?.type,
        title: data?.payload?.data?.document?.title,
        description: data?.payload?.data?.document?.description,
        extension: extension,
        sourceType: data?.payload?.data?.document?.source_type,
      });
      /* } */
    });
  };

  const EditableCell = ({
    value: initialValue,
    row: { index, original },
    column: { id }, // This is a custom function that we supplied to our table instance
  }) => {
    // We need to keep and update the state of the cell normally
    const [value, setValue] = useState(initialValue);
    const onChange = (e) => {
      setValue(e.target.value);
    };

    // We'll only update the external data when the input is blurred
    /* const onBlur = () => {
      setEditUuid("");
      editCell(index, id, value, original.uuid);
    }; */

    // If the initialValue is changed external, sync it up with our state
    useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);

    return edituuid === original.uuid ? (
      <div className="rename-input">
        {/* <input value={value} onChange={onChange} onBlur={onBlur} className="form-control" /> */}
        <input
          value={value}
          autoFocus
          onChange={onChange}
          className="form-control"
        />
        <button
          type="button"
          className="btn write-btn bg-success"
          disabled={value ? false : true}
          onClick={() => {
            setEditUuid("");
            editCell(index, id, value, original.uuid);
          }}
        >
          <img src={writeImg} alt="write-btn-img" />
        </button>
        <button
          type="button"
          className="btn cross-btn bg-danger"
          onClick={() => {
            setValue("");
            setEditUuid("");
          }}
        >
          <img src={crossImg} alt="cross-btn-img" className="cross-btn-img" />
        </button>
      </div>
    ) : (
      <>
        {/* {((original?.type === "text" && RoleRightsForModule("View", "Create Documents")) || (original?.type === "doc" && RoleRightsForModule("View", "Upload Documents"))) ? */}
        <p
          className="doc-name cursor-pointer"
          onClick={() => {
            previewOnClick(original.uuid, original?.type, original?.extension);
          }}
        >
          {initialValue ? initialValue : "-"}
          {/* <span> ({original.file_name})</span> */}
        </p>
        {original?.source_type === "text" && original?.type === "text" ? (
          <p className="doc-date">
            <img src={editImgIcn} alt="" /> Edited by{" "}
            {original?.updated_by_user?.first_name}{" "}
            {original?.updated_by_user?.last_name[0]}
            <br />
            at{" "}
            {moment(original.updated_at)
              .utc()
              .local()
              .format("MMM DD, YYYY hh:mm A")}
          </p>
        ) : (
          <p className="doc-date">
            <img src={editImgIcn} alt="" /> Uploaded by{" "}
            {original?.user?.first_name} {original?.user?.last_name[0]}
            <br />
            at{" "}
            {moment(original.updated_at)
              .utc()
              .local()
              .format("MMM DD, YYYY hh:mm A")}
          </p>
        )}
        {/* <Document file={pdFIle}/> */}
      </>
    );
  };

  const handleDeleteTags = async (labelUUID, documentUUID) => {
    Mixpanel.track("Delete tags button Clicked", {
      Page: "Documents tab",
    });

    let indexRow = null;
    const updatedRows = [...documentListData];
    const rowToUpdate = {
      ...updatedRows.find((d, i) => {
        if (d.uuid == documentUUID) {
          indexRow = i;
          return d;
        }
      }),
    };
    rowToUpdate["Labels"] = [
      ...rowToUpdate["Labels"].filter((d) => d.uuid !== labelUUID),
    ];
    updatedRows[indexRow] = rowToUpdate;

    setListOfDocuments(updatedRows);
    setDocumentsListForUpdate(updatedRows);
    setIsLoading(true);
    let { payload } = await dispatch(
      removeTags({ docid: documentUUID, labelid: labelUUID })
    );
    setIsLoading(false);
    if (payload.status === OK) {
      await dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          project_uuid: projectData?.projects[0]?.uuid,
          search: searchValue,
          type:
            subCategories === "Archive"
              ? "archive"
              : subCategories === "Starred"
              ? "favourite"
              : "",
        })
      );
      // await dispatch(labelListing(projectData?.projects[0]?.uuid));
    }
  };

  const resyncDocument = async (uuidData) => {
    let uuidArray = [];
    //THIS IS FOR GLOBAL RESYNC
    /* const syncInProgressDocuments = documentsListForUpdate.map((document) => {
      const selectedDocument = selectedRowsID.find(
        (row) => row.original.uuid === document.uuid
      );
      if (selectedDocument && document.is_synced === 2) {
        return true;
      } else {
        return false;
      }
    });
    if (syncInProgressDocuments.includes(true)) {
      console.log(syncInProgressDocuments, ":::Coming");
      return;
    } */
    /* updatedStatusDocuments.length > 0 &&
      updatedStatusDocuments.map((data) => {
        if (
          isDocsSyncInProgress.includes(data.documentUUID) &&
          data.is_synced !== 2
        ) {
          isDocsSyncInProgress.filter(
            (filterData) => filterData === data.documentUUID
          );
        }
      }); */
    // console.log(isDocsSyncInProgress, "isDocsSyncInProgress");
    /*  if (isDocsSyncInProgress) {
      return;
    } */

    if (uuidData && Array.isArray(uuidData)) {
      uuidArray = uuidArray.concat(uuidData);
    }
    else if (uuidData) {
      uuidArray.push(uuidData);
    } else {
      selectedRowsID.length > 0 &&
        selectedRowsID.map((data, index) => {
          uuidArray.push(data.original?.uuid);
        });
    }
    Mixpanel.track("Resync document button Clicked", {
      Page: "Documents tab",
    });

    const { payload } = await dispatch(
      resyncDocuments({
        values: uuidArray,
        project_uuid: projectData?.projects[0]?.uuid,
      })
    );
    setSelectedRowsID([]);
    if (payload.status === OK) {
      dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          project_uuid: projectData?.projects[0]?.uuid,
          search: searchValue,
          type:
            subCategories === "Archive"
              ? "archive"
              : subCategories === "Starred"
              ? "favourite"
              : "",
        })
      );
    }
  };

  const onUnarchiveClick = async (uuid) => {
    Mixpanel.track("Unarchieve doucment button clicked", {
      Page: "Archive tab",
    });
    const { payload } = await dispatch(
      syncSlice({
        document_uuid: uuid,
        project_uuid: projectData?.projects[0]?.uuid,
      })
    );
    if (payload.status === OK) {
      dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          search: searchValue,
          type: "archive",
          project_uuid: projectData?.projects[0]?.uuid,
        })
      );
      /* toggle(); */
    }
  };

  const handleTagUpdate = async (document, index) => {
    let labelToAdd = {
      uuid: document?.label?.uuid,
      name: document?.label?.name,
      color_hex: document?.label?.color_hex,
    };
    const updatedRows = [...documentListData];

    if (
      selectedRowsID &&
      selectedRowsID.length &&
      selectedRowsID.find(
        (row) => row.original.uuid === updatedRows[index].uuid
      )
    ) {
      selectedRowsID.map((row, i) => {
        let indexRow = null;
        const rowToUpdate = {
          ...updatedRows.find((d, i) => {
            if (d.uuid == row?.original?.uuid) {
              indexRow = i;
              return d;
            }
          }),
        };
        rowToUpdate["Labels"] = !!!rowToUpdate["Labels"].find(
          (doc) => doc.uuid == labelToAdd.uuid
        )
          ? [...rowToUpdate["Labels"], labelToAdd]
          : [...rowToUpdate["Labels"]];
        updatedRows[indexRow] = rowToUpdate;
      });
    } else {
      const rowToUpdate = { ...updatedRows[index] };
      rowToUpdate["Labels"] = !!!rowToUpdate["Labels"].find(
        (doc) => doc.uuid == labelToAdd.uuid
      )
        ? [...rowToUpdate["Labels"], labelToAdd]
        : [...rowToUpdate["Labels"]];
      updatedRows[index] = rowToUpdate;
    }
    setListOfDocuments(updatedRows);
    setDocumentsListForUpdate(updatedRows);
    setIsLoading(true);

    if (document) {
      let uuidArray = [];
      let selectedLabelId = [document.label.uuid];
      if (
        selectedRowsID?.filter(
          (d) => d?.original?.uuid == updatedRows[index]?.uuid
        )?.length
      ) {
        selectedRowsID.map((data) => {
          uuidArray.push(data?.original?.uuid);
        });
      } else {
        uuidArray.push(updatedRows[index]?.uuid);
      }
      let { payload } = await dispatch(
        labelDocument({ document_uuid: uuidArray, label_uuid: selectedLabelId })
      );
      setIsLoading(false);
      if (payload.status === 201) {
        dispatch(
          getDocuments({
            perPage: perPage,
            page: currentPage,
            project_uuid: projectData?.projects[0]?.uuid,
            search: searchValue,
            type:
              subCategories === "Archive"
                ? "archive"
                : subCategories === "Starred"
                ? "favourite"
                : "",
          })
        );
      }
    }
  };

  const toggleViewSummaryTextModal = (docData) => {
    setSummaryTextData(docData);
    modalData.current = docData;
    setCurrentModal("viewSummaryTextModal");
  };

  const columns = useMemo(() => {
    return [
      {
        Header: "",
        accessor: "Star",
        Cell: (data) => {
          return (
            <>
              {((data?.row?.original?.type === "text" &&
                RoleRightsForModule("Write", "Create Documents")) ||
                (data?.row?.original?.type === "doc" &&
                  RoleRightsForModule("Upload", "Upload Documents"))) && (
                <div className="d-flex align-items-center star-selct">
                  <div className="form-check me-1">
                    {/* data?.row?.original?.uuid */}
                    {/* <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="mt"
                /> */}
                  </div>
                  <img
                    src={data?.row?.original?.is_favourite === 0 ? star : favStar}
                    className="star-favourite-icon"
                    alt="favourite"
                    onClick={() => {
                      handleFavouriteUnfavourite(
                        data?.row?.original?.uuid,
                        data?.row?.original?.is_favourite
                      );
                    }}
                  />
                </div>
              )}
            </>
          );
        },
      },
      {
        Header: "",
        accessor: "file_type",
        sortType: (a, b) => {
          return ("" + a?.original?.extension).localeCompare(
            b?.original?.extension
          );
        },
        Cell: (props) => {
          return (
            <>
              {(props?.row?.original?.extension === "doc" ||
                props?.row?.original?.extension === "docx") &&
                props?.row?.original?.source_type === "doc" && (
                  <img className="doc_imgicn" src={docImg} alt="pdf-icn" />
                )}
              {props?.row?.original?.extension === "pdf" && (
                <img className="doc_imgicn" src={pdfImg} alt="pdf-icn" />
              )}
              {props?.row?.original?.type === "text" &&
                props?.row?.original?.source_type === "text" && (
                  <img className="doc_imgicn" src={docImg} alt="pdf-icn" />
                )}
              {props?.row?.original?.source_type === "single_page" && (
                <img className="doc_imgicn pt-2" src={webImg} alt="xml-icn" />
              )}
              {props?.row?.original?.source_type === "sitemap" && (
                <img className="doc_imgicn pt-2" src={sitemapImg} alt="xml-icn" />
              )}
              {props?.row?.original?.source_type === "rss_feed" && (
                <img className="doc_imgicn pt-2" src={rssImg} alt="xml-icn" />
              )}
            </>
          );
        },
      },
      {
        Header: "Documents",
        accessor: "title",
        sortType: (a, b) => {
          return ("" + a?.original?.title).localeCompare(b?.original?.title);
        },
        Cell: EditableCell,
      },
      /* {
        Header: "",
        accessor: "summery",
        Cell: () => {
          return (
            <>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus hendrerit neque id posuere condimentum. Nam tincidunt blandit elit sit amet ullamcorper.</p>
            </>
          )
        },
      }, */
      {
        Header: "Tags",
        accessor: "Labels",
        disableSortBy: true,
        Cell: (props) => {
          return (
            <>
              {props?.row?.original?.Labels.length > 0 &&
                props?.row?.original?.Labels.map((data, index) => (
                  <div key={index} className="tags-label-main">
                    <div
                      className={`tags-label ${getColoroCodeString(
                        data?.color_hex
                      )}`}
                      key={index}
                    >
                      <span
                        className={`tags-txt ${getColoroCodeStringText(
                          data?.color_hex
                        )}`}
                      >
                        {data.name.length > 10
                          ? data.name.slice(0, 15) + "..."
                          : data.name}
                      </span>
                      <button
                        type="button"
                        className="btn"
                        onClick={() => {
                          handleDeleteTags(
                            data?.uuid,
                            props?.row?.original?.uuid
                          );
                        }}
                      >
                        <svg
                          className="close-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="13.414"
                          height="13.414"
                          viewBox="0 0 13.414 13.414"
                        >
                          <g
                            id="Group_31758"
                            data-name="Group 31758"
                            transform="translate(0.707 0.707)"
                          >
                            <path
                              id="Path_48155"
                              data-name="Path 48155"
                              d="M0,0,12,12"
                              fill="none"
                              stroke={`${getColoroCodeCloseText(
                                data?.color_hex
                              )}`}
                              strokeWidth="2"
                            />
                            <path
                              id="Path_48154"
                              data-name="Path 48154"
                              d="M12,0,0,12"
                              fill="none"
                              stroke={`${getColoroCodeCloseText(
                                data?.color_hex
                              )}`}
                              strokeWidth="2"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "is_synced",
        disableSortBy: true,
        Cell: (data) => <DocumentStatus data={data} />
        // Cell: (data) => {
        //   const isSynced =
        //     data?.row?.original?.is_synced === 1 ||
        //     updatedStatusDocuments.some(
        //       (document) =>
        //         document.documentUUID === data?.row?.original?.uuid &&
        //         document.is_synced === 1
        //     );
        //   const syncedValue = isSynced ? 1 : 0;
        //   let syncedAt = "";
        //   if (syncedValue === 1) {
        //     const foundDocument = updatedStatusDocuments.find(
        //       (document) =>
        //         document.documentUUID === data?.row?.original?.uuid &&
        //         document.is_synced === 1
        //     );
        //     syncedAt = foundDocument ? foundDocument.synced_at : null;
        //   }
        //   const isUnSynced =
        //     data?.row?.original?.is_synced === 0 ||
        //     updatedStatusDocuments.some((document) => {
        //       if (
        //         document.documentUUID === data?.row?.original?.uuid &&
        //         document.is_synced === 0
        //       ) {
        //         return true; // This indicates the condition is met
        //       }
        //       return false; // This indicates the condition is not met
        //     });
        //   const processedDocument = processedDocuments.find(document => document.documentUUID === data?.row?.original?.uuid);
        //   let trainingStatus = data?.row?.original?.training_status;
        //   if (processedDocument?.training_status) {
        //     trainingStatus = processedDocument.training_status ?? null;
        //   }
  
        //   return (
        //     <>
        //       {/*
        //         SYNCED: 1,
        //         UNSYNCED: 0,
        //         SYNC_IN_PROGRESS: 2 
        //       */}
        //       {(data?.row?.original?.is_synced === 1 || syncedValue === 1) &&
        //         isUnSynced !== true && (
        //           <>
        //             <span className="status status-text sync">
        //               <img className="syncicn-img" src={syncImg} alt="" /> Trained
        //             </span>
        //             {(data?.row?.original?.synced_at !== null ||
        //               syncedAt !== null) &&
        //               isUnSynced !== true && (
        //                 <p class="doc-date mt-2 doc-date-text">
        //                   {syncedAt !== null
        //                     ? moment(syncedAt)
        //                         .utc()
        //                         .local()
        //                         .format("MMM DD, YYYY hh:mm A")
        //                     : moment(data?.row?.original?.synced_at)
        //                         .utc()
        //                         .local()
        //                         .format("MMM DD, YYYY hh:mm A")}
  
        //                   {syncedAt !== null ? (
        //                     <span className="d-block">
        //                       {getTimeAgoString(syncedAt)}
        //                     </span>
        //                   ) : (
        //                     <span className="d-block">
        //                       {getTimeAgoString(data?.row?.original?.synced_at)}
        //                     </span>
        //                   )}
        //                 </p>
        //               )}
        //           </>
        //         )}
  
        //       {/*  {(data?.row?.original?.is_synced === 0 &&
        //         data?.row?.original?.failed_reason !== null) ||
        //       (isUnSynced !== "" && isUnSynced !== false) ? (
        //         <div
        //         // className="status-tooltip-container"
        //         // data-tooltip={isUnSynced!== false && isUnSynced!== '' ? isUnSynced :data?.row?.original?.failed_reason}
        //         >
        //           <span className="status status-text notsync">
        //             <img className="syncicn-img" src={notsync_icn} alt="" /> Not
        //             Sync
        //           </span>
        //         </div>
        //       ) : (
        //         <> */}
        //       {(data?.row?.original?.is_synced === 0 || isUnSynced === true) &&
        //         syncedValue !== 1 && (
        //           <span className="status status-text notsync">
        //             <img className="syncicn-img" src={notsync_icn} alt="" /> Not
        //             Trained
        //           </span>
        //         )}
        //       {/*   </>
        //       )} */}
        //       {/* {data?.row?.original?.is_synced === 0 && (
        //         <span className="status status-text notsync">
        //         <img className="syncicn-img" src={notsync_icn} alt="" /> Not
        //         Sync
        //         </span>
        //       )} */}
  
        //       {data?.row?.original?.is_synced === 2 &&
        //         (!syncedValue || syncedValue !== 1) &&
        //         (isUnSynced === "" || isUnSynced === false) && (
        //           <span className="status status-text inporgesssync">
        //             <img className="syncicn-img" src={inProgressImg} alt="" />{" "}
        //             Training
        //           </span>
        //         )}
        //       {Boolean(trainingStatus) && (
        //         <p className="mt-2 doc-date-text">{trainingStatus}</p>
        //       )}
        //     </>
        //   );
        // },
      },
  
      {
        Header: "Action",
        Cell: (data) => <DocumentAction
            data={data}
            subCategories={subCategories}
            setSubCategories={setSubCategories}
            handleArchive={handleArchive}
            syncUnsyncToggle={syncUnsyncToggle}
            resyncDocument={resyncDocument}
            setUuid={setUuid}
            toggleViewSummaryTextModal={toggleViewSummaryTextModal}
            setEditUuid={setEditUuid}
            setCurrentModal={setCurrentModal}
            setFileName={setFileName}
            onUnarchiveClick={onUnarchiveClick}
          />,
        // Cell: (props) => {
        //   const isSynced =
        //     props?.row?.original?.is_synced === 1 ||
        //     updatedStatusDocuments.some(
        //       (document) =>
        //         document.documentUUID === props?.row?.original?.uuid &&
        //         document.is_synced === 1
        //     );
  
        //   const syncedValue = isSynced ? 1 : 0;
        //   const isUnSynced =
        //     props?.row?.original?.is_synced === 0 ||
        //     updatedStatusDocuments.some((document) => {
        //       if (
        //         document.documentUUID === props?.row?.original?.uuid &&
        //         document.is_synced === 0
        //       ) {
        //         return true; // This indicates the condition is met
        //       }
        //       return false; // This indicates the condition is not met
        //     });
  
        //   const checkSyncInProgessToDisableButton =
        //     props?.row?.original?.is_synced !== 2 ||
        //     syncedValue === 1 ||
        //     isUnSynced === true;
  
        //   return (
        //     <>
        //       {
        //         <div className="dropdown action-dropdown">
        //           {((props?.row?.original?.type === "text" &&
        //             !NoModuleRights("Create Documents")) ||
        //             (props?.row?.original?.type === "doc" &&
        //               !NoModuleRights("Upload Documents"))) && (
        //             <button
        //               className="btn dropdown-toggle"
        //               type="button"
        //               data-bs-toggle="dropdown"
        //               aria-expanded="false"
        //             >
        //               <img src={ActionImg} alt="" />
        //             </button>
        //           )}
        //           <ul className="dropdown-menu dropdown-menu-end">
        //             {/* SYNCED- Trained: 1,
        //             UNSYNCED- Untrain: 0,
        //             SYNC_IN_PROGRESS- Training: 2
        //         */}
  
        //             {subCategories === "Documents" && (
        //               <>
        //                 {((props?.row?.original?.type === "doc" &&
        //                   RoleRightsForModule("Delete", "Upload Documents")) ||
        //                   (props?.row?.original?.type === "text" &&
        //                     RoleRightsForModule(
        //                       "Write",
        //                       "Create Documents"
        //                     ))) && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       (props?.row?.original?.is_synced !== 2 ||
        //                         syncedValue === 1 ||
        //                         isUnSynced === true) &&
        //                         toggleViewSummaryTextModal(props?.row?.original);
        //                     }}
        //                   >
        //                     <span>
        //                       <img
        //                         className="lang-cmn-icn"
        //                         src={viewSummary}
        //                         alt="fileicn"
        //                         height={18}
        //                         width={18}
        //                       />
        //                     </span>{" "}
        //                     Summary
        //                   </li>
        //                 )}
        //                 {((props?.row?.original?.source_type === "single_page" &&
        //                   RoleRightsForModule("Write", "Create Documents")) ||
        //                   (props?.row?.original?.source_type === "sitemap" &&
        //                     RoleRightsForModule("Write", "Create Documents")) ||
        //                   (props?.row?.original?.source_type === "rss_feed" &&
        //                     RoleRightsForModule(
        //                       "Write",
        //                       "Create Documents"
        //                     ))) && (
        //                   <li
        //                     className={`dropdown-item mt-1`}
        //                     onClick={() =>
        //                       window.open(props?.row?.original?.source_url)
        //                     }
        //                   >
        //                     <span>
        //                       <img
        //                         className="lang-cmn-icn"
        //                         src={RedirectIcon}
        //                         alt="fileicn"
        //                         height={15}
        //                         width={15}
        //                       />
        //                     </span>{" "}
        //                     Source
        //                   </li>
        //                 )}
        //                 {((props?.row?.original?.type === "doc" &&
        //                   RoleRightsForModule("Delete", "Upload Documents")) ||
        //                   (props?.row?.original?.type === "text" &&
        //                     RoleRightsForModule(
        //                       "Delete",
        //                       "Create Documents"
        //                     ))) && (
        //                   <li
        //                     className={`dropdown-item mt-1`}
        //                     onClick={() => {
        //                       setCurrentModal("deleteModal");
        //                       setUuid(props?.row?.original?.uuid);
        //                     }}
        //                   >
        //                     <span>
        //                       <img src={trashImg} alt="" />
        //                     </span>{" "}
        //                     Delete
        //                   </li>
        //                 )}
        //                 {RoleRightsForModule("Write", "Create Documents") && (
        //                   <li
        //                     className="dropdown-item mt-1"
        //                     onClick={() => {
        //                       setEditUuid(props?.row?.original?.uuid);
        //                     }}
        //                   >
        //                     <span>
        //                       <img src={renameImg} alt="" />
        //                     </span>{" "}
        //                     Rename
        //                   </li>
        //                 )}
        //                 {((props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Archive", "Create Documents")) ||
        //                   (props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule(
        //                       "Archive",
        //                       "Upload Documents"
        //                     ))) && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       (props?.row?.original?.is_synced !== 2 ||
        //                         syncedValue === 1 ||
        //                         isUnSynced === true) &&
        //                         handleArchive(props?.row?.original?.uuid);
        //                       /* setCurrentModal("archiveModal");
        //                   setUuid(props?.row?.original?.uuid);
        //                   setFileName(props?.row?.original?.title); */
        //                     }}
        //                   >
        //                     <span>
        //                       <img src={archiveicn} alt="" />
        //                     </span>{" "}
        //                     Archive
        //                   </li>
        //                 )}
        //                 {(((props?.row?.original?.is_synced === 0 ||
        //                   isUnSynced === true) &&
        //                   props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Sync", "Create Documents")) ||
        //                   ((props?.row?.original?.is_synced === 0 ||
        //                     isUnSynced === true) &&
        //                     props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule("Sync", "Upload Documents"))) && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       (props?.row?.original?.is_synced !== 2 ||
        //                         syncedValue === 1 ||
        //                         isUnSynced === true) &&
        //                         syncUnsyncToggle(props?.row?.original?.uuid, 0);
        //                     }}
        //                   >
        //                     <span>
        //                       {(props?.row?.original?.is_synced === 0 ||
        //                         isUnSynced === true) && (
        //                         <img src={actionSync} alt="" />
        //                       )}
        //                       {/*  {(props?.row?.original?.is_synced === 2 ||
        //                     props?.row?.original?.is_synced === 1) && (
        //                       <img src={unsyncImg} alt="" />
        //                     )} */}
        //                     </span>{" "}
        //                     {(props?.row?.original?.is_synced === 0 ||
        //                       isUnSynced === true) &&
        //                       "Train"}
        //                   </li>
        //                 )}
  
        //                 {(((props?.row?.original?.is_synced === 2 ||
        //                   props?.row?.original?.is_synced === 1) &&
        //                   isUnSynced !== true &&
        //                   props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Unsync", "Create Documents")) ||
        //                   ((props?.row?.original?.is_synced === 2 ||
        //                     props?.row?.original?.is_synced === 1) &&
        //                     isUnSynced !== true &&
        //                     props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule(
        //                       "Unsync",
        //                       "Upload Documents"
        //                     ))) && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       (props?.row?.original?.is_synced !== 2 ||
        //                         syncedValue === 1 ||
        //                         isUnSynced === true) &&
        //                         syncUnsyncToggle(
        //                           props?.row?.original?.uuid,
        //                           2
        //                           /* isSynced !== 1
        //                             ? props?.row?.original?.is_synced
        //                             : 1 */
        //                         );
        //                       /* setCurrentModal("syncUnsycModal"); */
        //                       /* setUuid(props?.row?.original?.uuid);
        //                   setSyncUnsync(props?.row?.original?.is_synced);
        //                   setFileName(props?.row?.original?.title); */
        //                     }}
        //                   >
        //                     <span>
        //                       {(props?.row?.original?.is_synced === 2 ||
        //                         props?.row?.original?.is_synced === 1) &&
        //                         isUnSynced !== true && (
        //                           <img src={unsyncImg} alt="" />
        //                         )}
        //                     </span>{" "}
        //                     {(props?.row?.original?.is_synced === 2 ||
        //                       props?.row?.original?.is_synced === 1) &&
        //                       isUnSynced !== true &&
        //                       "Untrain"}
        //                   </li>
        //                 )}
  
        //                 {RoleRightsForModule("Write", "Create Documents") &&
        //                   !isUnSynced && (
        //                     <li
        //                       className={
        //                         !checkSyncInProgessToDisableButton
        //                           ? "dropdown-item-disabled dropdown-item mt-1"
        //                           : `dropdown-item mt-1`
        //                       }
        //                       onClick={() => {
        //                         (props?.row?.original?.is_synced !== 2 ||
        //                           syncedValue === 1 ||
        //                           isUnSynced === true) &&
        //                           resyncDocument(props?.row?.original?.uuid);
        //                       }}
        //                     >
        //                       <span>
        //                         <img
        //                           src={resyncImg}
        //                           width={18}
        //                           height={18}
        //                           alt=""
        //                         />
        //                       </span>{" "}
        //                       Retrain
        //                     </li>
        //                   )}
  
        //                 {props?.row?.original?.type === "text" &&
        //                   props?.row?.original?.source_type === "text" &&
        //                   RoleRightsForModule("Write", "Create Documents") && (
        //                     <li
        //                       className={
        //                         !checkSyncInProgessToDisableButton
        //                           ? "dropdown-item-disabled dropdown-item mt-1"
        //                           : `dropdown-item mt-1`
        //                       }
        //                       onClick={() => {
        //                         (props?.row?.original?.is_synced !== 2 ||
        //                           syncedValue === 1 ||
        //                           isUnSynced === true) &&
        //                           setSubCategories("createNewDoc");
        //                         setUuid(props?.row?.original?.uuid);
        //                       }}
        //                     >
        //                       <span>
        //                         <img className="edit-icn" src={editImg} alt="" />
        //                       </span>{" "}
        //                       Edit
        //                     </li>
        //                   )}
        //               </>
        //             )}
        //             {subCategories === "Starred" && (
        //               <>
        //                 {((props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Write", "Create Documents")) ||
        //                   (props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule(
        //                       "Delete",
        //                       "Upload Documents"
        //                     ))) && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       toggleViewSummaryTextModal(props?.row?.original);
        //                       /* setCurrentModal("unarchiveModal");
        //                 setUuid(props?.row?.original?.uuid);
        //                 setFileName(props?.row?.original?.title); */
        //                       // onUnarchiveClick(props?.row?.original?.uuid)
        //                     }}
        //                   >
        //                     <span>
        //                       <img
        //                         className="lang-cmn-icn"
        //                         src={viewSummary}
        //                         alt="fileicn"
        //                         height={18}
        //                         width={18}
        //                       />
        //                     </span>{" "}
        //                     Summary
        //                   </li>
        //                 )}
        //                 {((props?.row?.original?.source_type === "single_page" &&
        //                   RoleRightsForModule("Write", "Create Documents")) ||
        //                   (props?.row?.original?.source_type === "sitemap" &&
        //                     RoleRightsForModule("Write", "Create Documents")) ||
        //                   (props?.row?.original?.source_type === "rss_feed" &&
        //                     RoleRightsForModule(
        //                       "Write",
        //                       "Create Documents"
        //                     ))) && (
        //                   <li
        //                     className={`dropdown-item mt-1`}
        //                     onClick={() =>
        //                       window.open(props?.row?.original?.source_url)
        //                     }
        //                   >
        //                     <span>
        //                       <img
        //                         className="lang-cmn-icn"
        //                         src={RedirectIcon}
        //                         alt="fileicn"
        //                         height={15}
        //                         width={15}
        //                       />
        //                     </span>{" "}
        //                     Source
        //                   </li>
        //                 )}
        //                 <li
        //                   className="dropdown-item mt-1"
        //                   onClick={() => {
        //                     setEditUuid(props?.row?.original?.uuid);
        //                   }}
        //                 >
        //                   <span>
        //                     <img src={renameImg} alt="" />
        //                   </span>{" "}
        //                   Rename
        //                 </li>
        //                 {((props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Archive", "Create Documents")) ||
        //                   (props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule(
        //                       "Archive",
        //                       "Upload Documents"
        //                     ))) && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       handleArchive(props?.row?.original?.uuid);
        //                       /* setCurrentModal("archiveModal");
        //                 setUuid(props?.row?.original?.uuid);
        //                 setFileName(props?.row?.original?.title); */
        //                     }}
        //                   >
        //                     <span>
        //                       <img src={archiveicn} alt="" />
        //                     </span>{" "}
        //                     Archive
        //                   </li>
        //                 )}
        //                 {(((props?.row?.original?.is_synced === 0 ||
        //                   isUnSynced === true) &&
        //                   props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Sync", "Create Documents")) ||
        //                   ((props?.row?.original?.is_synced === 0 ||
        //                     isUnSynced === true) &&
        //                     props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule("Sync", "Upload Documents"))) && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       (props?.row?.original?.is_synced !== 2 ||
        //                         syncedValue === 1 ||
        //                         isUnSynced === true) &&
        //                         syncUnsyncToggle(props?.row?.original?.uuid, 0);
        //                     }}
        //                   >
        //                     <span>
        //                       {(props?.row?.original?.is_synced === 0 ||
        //                         isUnSynced === true) && (
        //                         <img src={actionSync} alt="" />
        //                       )}
        //                       {/*  {(props?.row?.original?.is_synced === 2 ||
        //                     props?.row?.original?.is_synced === 1) && (
        //                       <img src={unsyncImg} alt="" />
        //                     )} */}
        //                     </span>{" "}
        //                     {(props?.row?.original?.is_synced === 0 ||
        //                       isUnSynced === true) &&
        //                       "Train"}
        //                   </li>
        //                 )}
  
        //                 {(((props?.row?.original?.is_synced === 2 ||
        //                   props?.row?.original?.is_synced === 1) &&
        //                   isUnSynced !== true &&
        //                   props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Unsync", "Create Documents")) ||
        //                   ((props?.row?.original?.is_synced === 2 ||
        //                     props?.row?.original?.is_synced === 1) &&
        //                     isUnSynced !== true &&
        //                     props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule(
        //                       "Unsync",
        //                       "Upload Documents"
        //                     ))) && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       (props?.row?.original?.is_synced !== 2 ||
        //                         syncedValue === 1 ||
        //                         isUnSynced === true) &&
        //                         syncUnsyncToggle(props?.row?.original?.uuid, 1);
        //                     }}
        //                   >
        //                     <span>
        //                       {(props?.row?.original?.is_synced === 2 ||
        //                         props?.row?.original?.is_synced === 1) &&
        //                         isUnSynced !== true && (
        //                           <img src={unsyncImg} alt="" />
        //                         )}
        //                     </span>{" "}
        //                     {(props?.row?.original?.is_synced === 2 ||
        //                       props?.row?.original?.is_synced === 1) &&
        //                       isUnSynced !== true &&
        //                       "Untrain"}
        //                   </li>
        //                 )}
  
        //                 {props?.row?.original?.type === "text" && (
        //                   <li
        //                     className={
        //                       !checkSyncInProgessToDisableButton
        //                         ? "dropdown-item-disabled dropdown-item mt-1"
        //                         : `dropdown-item mt-1`
        //                     }
        //                     onClick={() => {
        //                       setSubCategories("createNewDoc");
        //                       setUuid(props?.row?.original?.uuid);
        //                     }}
        //                   >
        //                     <span>
        //                       <img className="edit-icn" src={editImg} alt="" />
        //                     </span>{" "}
        //                     Edit
        //                   </li>
        //                 )}
        //               </>
        //             )}
  
        //             {subCategories === "Archive" && (
        //               <>
        //                 {((props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Write", "Create Documents")) ||
        //                   (props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule(
        //                       "Delete",
        //                       "Upload Documents"
        //                     ))) && (
        //                   <li
        //                     className="dropdown-item mt-1"
        //                     onClick={() => {
        //                       toggleViewSummaryTextModal(props?.row?.original);
        //                       /* setCurrentModal("unarchiveModal");
        //                 setUuid(props?.row?.original?.uuid);
        //                 setFileName(props?.row?.original?.title); */
        //                       // onUnarchiveClick(props?.row?.original?.uuid)
        //                     }}
        //                   >
        //                     <span>
        //                       <img
        //                         className="lang-cmn-icn"
        //                         src={viewSummary}
        //                         height={18}
        //                         width={18}
        //                         alt="fileicn"
        //                       />
        //                     </span>{" "}
        //                     Summary
        //                   </li>
        //                 )}
        //                 {((props?.row?.original?.source_type === "single_page" &&
        //                   RoleRightsForModule("Write", "Create Documents")) ||
        //                   (props?.row?.original?.source_type === "sitemap" &&
        //                     RoleRightsForModule("Write", "Create Documents")) ||
        //                   (props?.row?.original?.source_type === "rss_feed" &&
        //                     RoleRightsForModule(
        //                       "Write",
        //                       "Create Documents"
        //                     ))) && (
        //                   <li
        //                     className={`dropdown-item mt-1`}
        //                     onClick={() =>
        //                       window.open(props?.row?.original?.source_url)
        //                     }
        //                   >
        //                     <span>
        //                       <img
        //                         className="lang-cmn-icn"
        //                         src={RedirectIcon}
        //                         alt="fileicn"
        //                         height={15}
        //                         width={15}
        //                       />
        //                     </span>{" "}
        //                     Source
        //                   </li>
        //                 )}
        //                 {((props?.row?.original?.type === "doc" &&
        //                   RoleRightsForModule("Delete", "Upload Documents")) ||
        //                   (props?.row?.original?.type === "text" &&
        //                     RoleRightsForModule(
        //                       "Delete",
        //                       "Create Documents"
        //                     ))) && (
        //                   <li
        //                     className="dropdown-item mt-1"
        //                     onClick={() => {
        //                       setCurrentModal("deleteModal");
        //                       setUuid(props?.row?.original?.uuid);
        //                       setFileName(props?.row?.original?.title);
        //                     }}
        //                   >
        //                     <span>
        //                       <img src={trashImg} alt="" />
        //                     </span>{" "}
        //                     Delete
        //                   </li>
        //                 )}
        //                 {((props?.row?.original?.type === "text" &&
        //                   RoleRightsForModule("Unarchive", "Create Documents")) ||
        //                   (props?.row?.original?.type === "doc" &&
        //                     RoleRightsForModule(
        //                       "Unarchive",
        //                       "Upload Documents"
        //                     ))) && (
        //                   <li
        //                     className="dropdown-item mt-1"
        //                     onClick={() => {
        //                       onUnarchiveClick(props?.row?.original?.uuid);
        //                       /* setCurrentModal("unarchiveModal");
        //                 setUuid(props?.row?.original?.uuid);
        //                 setFileName(props?.row?.original?.title); */
        //                       // onUnarchiveClick(props?.row?.original?.uuid)
        //                     }}
        //                   >
        //                     <span>
        //                       <img
        //                         className="lang-cmn-icn"
        //                         src={archiveicn}
        //                         alt="fileicn"
        //                       />
        //                     </span>{" "}
        //                     Unarchive
        //                   </li>
        //                 )}
        //               </>
        //             )}
        //           </ul>
        //         </div>
        //       }
        //     </>
        //   );
        // },
      },
    ];
  }, [
    subCategories,
    listOfDocuments?.length,
    socketDocumentData?.length,
    edituuid,
  ]);

  return (
    <>
      {showVerifyEmailModal && (
        <VerifyEmailModal
          isOpen={showVerifyEmailModal}
          toggle={() => setShowVerifyEmailModal(false)}
        />
      )}

      <DndProvider backend={HTML5Backend}>
        <div className="dashbord-content">
          <div className="dashbord-content-inner ">
            <DocumentSideMenu
              onClickActive={onClickActive}
              isActive={isActive}
              subCategories={subCategories}
              setSubCategories={setSubCategories}
              setCurrentModal={setCurrentModal}
              setLabelId={setLabelId}
              labelDeteleToggel={labelDeteleToggel}
              setSelectedLabel={setSelectedLabel}
              setSelectedCheckbox={setSelectedCheckbox}
              currentModal={currentModal}
              labelID={labelID}
              selectedCheckbox={selectedCheckbox}
              selectedRowsID={selectedRowsID}
              setPerPage={setPerPage}
              setCurrentPage={setCurrentPage}
            />
            {
              subCategories === "Documents" &&
              searchValue.length <= 0 &&
              !documentListLoading &&
              (documentListing?.documentListing?.length <= 0 ||
                documentListing?.documentListing === undefined) ? (
                <CreateDocument
                  setSubCategories={setSubCategories}
                  documentLength={documentLength}
                  subCategories={subCategories}
                />
              ) : (
                subCategories !== "createNewDoc" &&
                subCategories !== "filePreview" && (
                  <div className="intro-table-search container-fluid content-right-box">
                    <DashboardHeader
                      setCurrentModal={setCurrentModal}
                      setSubCategories={setSubCategories}
                      title="Documents"
                      perPage={perPage}
                      currentPage={currentPage}
                      selectedRowsID={selectedRowsID}
                      setSearchValue={setSearchValue}
                      searchValue={searchValue}
                      labelListingData={labelArray}
                      subCategories={subCategories}
                      setPerPage={setPerPage}
                      setCurrentPage={setCurrentPage}
                      handleDelete={handleDelete}
                      resyncDocument={resyncDocument}
                      currentModal={currentModal}
                    />
                    <ReactTable
                      isLoading={
                        listOfDocuments?.length <= 0 && documentListLoading
                      }
                      className={`${
                        subCategories === "Archive"
                          ? "dashbord-table-archived dashbord-table-newdesign summery-change-arc"
                          : subCategories === "Starred"
                          ? "dashbord-table-stared dashbord-table-newdesign summery-change-star"
                          : "dashbord-table dashbord-table-newdesign summery-change-doc"
                      }`}
                      columns={
                        subCategories === "Archive"
                          ? columns.filter(
                              (d) =>
                                d.accessor !== "is_synced" &&
                                d.accessor !== "Star"
                            )
                          : columns
                      }
                      data={
                        isLoading || documentListLoading || removeTagsLoading
                          ? listOfDocuments.length > 0
                            ? listOfDocuments
                            : []
                          : socketDocumentData?.length > 0
                          ? socketDocumentData
                          : []
                      }
                      currentPage={currentPage}
                      perPage={perPage}
                      totalCount={total_records}
                      setSelectedRowsID={setSelectedRowsID}
                      selectedRowsID={selectedRowsID}
                      handlePerPage={handleTotalPage}
                      isCheckBox={true}
                      onPageChange={(page) => {
                        handleCurrentPage(page);
                      }}
                      isDocumentListing={true}
                      handleTagUpdate={handleTagUpdate}
                    />
                  </div>
                )
              )
              // :
              // <CreateDocument setSubCategories={setSubCategories} documentLength={documentLength} subCategories={subCategories} />
            }

            {/* {subCategories === "Archive" && (
              <div className="intro-table-search container-fluid">
                <DashboardHeader
                  setCurrentModal={setCurrentModal}
                  setSubCategories={setSubCategories}
                  setSearchValue={setSearchValue}
                  searchValue={searchValue}
                  title="Archived"
                />
                <ArchiveDocuments
                  className="dashbord-table-archived"
                  perPage={perPage}
                  setPerPage={setPerPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  currentModal={currentModal}
                  setCurrentModal={setCurrentModal}
                  uuid={uuid}
                  setUuid={setUuid}
                  handleCurrentPage={handleCurrentPage}
                  toggle={toggleModal}
                  onConfirm={handleDelete}
                  onUnarchiveConfirm={handleArchive}
                />
              </div>
            )}

            {subCategories === "Starred" && (
              <div className="intro-table-search container-fluid">
                <DashboardHeader
                  setCurrentModal={setCurrentModal}
                  setSubCategories={setSubCategories}
                  setSearchValue={setSearchValue}
                  searchValue={searchValue}
                  title="Starred"
                />
                <StarredDocuments
                  className="dashbord-table-stared"
                  perPage={perPage}
                  setPerPage={setPerPage}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  currentModal={currentModal}
                  setCurrentModal={setCurrentModal}
                  handleArchive={handleArchive}
                  uuid={uuid}
                  setUuid={setUuid}
                  setSyncUnsync={setSyncUnsync}
                  syncUnsync={syncUnsync}
                  toggle={toggleModal}
                  setEditUuid={setEditUuid}
                  edituuid={edituuid}
                  handleCurrentPage={handleCurrentPage}
                  subCategories={subCategories}
                  setSubCategories={setSubCategories}
                />
              </div>
            )} */}

            {subCategories === "createNewDoc" && (
              <CreateEditorDocumentModal
                setSubCategories={setSubCategories}
                perPage={perPage}
                searchValue={searchValue}
                currentPage={currentPage}
                editUUID={uuid}
                setEditUUID={setUuid}
                fromFilePreview={isFromFilePreview}
                previousSubCategories={previousSubCategories}
              />
            )}
            {subCategories === "filePreview" && (
              <FilePreviewModal
                title={docUrl?.title}
                src={docUrl?.url}
                type={docUrl?.type}
                sourceType={docUrl?.sourceType}
                textTitle={docUrl?.title}
                textDescription={docUrl?.description}
                extension={docUrl?.extension}
                setDocUrl={setDocUrl}
                subCategories={subCategories}
                setSubCategories={setSubCategories}
                setEditUuid={setEditUuid}
                uuid={uuid}
                setUuid={setUuid}
                perPage={perPage}
                currentPage={currentPage}
                currentModal={currentModal}
                setCurrentModal={setCurrentModal}
                toggleModal={toggleModal}
                handleDelete={handleEditorDelete}
                setIsFromFilePreview={setIsFromFilePreview}
                previousSubCategories={previousSubCategories}
              />
            )}
          </div>

          {/* {subCategories === "createNewDoc" && (
            <CreateEditorDocumentModal
              setSubCategories={setSubCategories}
              perPage={perPage}
              currentPage={currentPage}
              editUUID={uuid}
              setEditUUID={setUuid}
            />
          )}
          {subCategories === "filePreview" && (
            <FilePreviewModal
              title={docUrl?.file_name}
              src={docUrl?.url}
              type={docUrl?.type}
              textTitle={docUrl?.title}
              textDescription={docUrl?.description}
              extension={docUrl?.extension}
              setDocUrl={setDocUrl}
              setSubCategories={setSubCategories}
              setEditUuid={setEditUuid}
            />
          )} */}
        </div>
      </DndProvider>
      {/* {currentModal === "uploadDocModal" && (
        <UploadDocumentModal
          isOpen={currentModal === "uploadDocModal"}
          toggle={toggleModal}
          perPage={perPage}
          currentPage={currentPage}
          setSubCategories={setSubCategories}
        />
      )} */}
      {currentModal === "deleteModal" && (
        <ConfirmationModal
          title={"Delete Confirmation"}
          isOpen={currentModal === "deleteModal"}
          toggle={toggleModal}
          onConfirm={handleDelete}
          message="Are you sure you want to delete this document?"
        />
      )}
      {currentModal === "viewSummaryTextModal" && (
        <ViewSummayModal
          title={"View Summary"}
          isOpen={currentModal === "viewSummaryTextModal"}
          setSummaryText={setSummaryText}
          summaryText={summaryText}
          documentData={summaryTextData}
          perPage={perPage}
          page={currentPage}
          toggle={toggleModal}
          searchValue={searchValue}
          subCategories={subCategories}
          modalData={{ ...modalData.current }}
        />
      )}
      {/* {currentModal === "archiveModal" && (
        <ConfirmationModal
          title={"Archive"}
          isOpen={currentModal === "archiveModal"}
          toggle={toggleModal}
          onConfirm={handleArchive}
          message="Are you sure you want to archive this document?"
          fileName={fileName}
        />
      )} */}
      {/* {currentModal === "syncUnsycModal" && (
        <ConfirmationModal
          title={"Sync-Unsync"}
          isOpen={currentModal === "syncUnsycModal"}
          toggle={toggleModal}
          onConfirm={syncUnsyncToggle}
          message="Are you sure you want to sync-unsync this document?"
          fileName={fileName}
        />
      )} */}
      {/* {currentModal === "labelDeleteModal" && (
        <ConfirmationModal
          title={"Delete Label Confirmation"}
          isOpen={currentModal === "labelDeleteModal"}
          toggle={toggleModal}
          onConfirm={handleDeleteLabel}
          message="Are you sure you want to delete this label?"
        />
      )} */}
      {/* {currentModal === "labelModal" && (
        <LabelModal
          isOpen={currentModal === "labelModal"}
          toggle={toggleModal}
          labelID={labelID}
          setLabelId={setLabelId}
          selectedLabel={selectedLabel}
          selectedCheckbox={selectedCheckbox}
        />
        
      )} */}
      {/* <DemoHightlight /> */}
    </>
  );
};

export default Dashboard;
